// extracted by mini-css-extract-plugin
export var closeButton = "_18-3";
export var header = "_18-0";
export var link = "_18-1";
export var retryButton = "_18-2";